// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"79962436","135":"864aaaf1","422":"a62087d5","787":"40b1908b"}[chunkId] + ".chunk.js";
};